import classNames from 'classnames';

import SvgIcon from 'components/SvgIcon';

import type { CopyButtonProps } from './types';

import copyButtonStyles from './styles';

const CopyButton = ({ isActive, onClick, compactMode }: CopyButtonProps) => {
  const styles = copyButtonStyles();

  return (
    <li
      className={classNames(styles.root, 'general', { compact: compactMode })}
      data-testid="copy_button"
      role="presentation"
      onClick={onClick}
      data-pulse-name="copy_button"
      data-pulse-clickable="true"
    >
      <SvgIcon
        name={isActive ? 'done-gen' : 'link-gen'}
        className={classNames(
          styles.copyButtonIconHolder,
          'copy',
          { active: isActive },
          'general',
          { compact: compactMode },
        )}
      />
      {!compactMode && (
        <span className={styles.copyButtonTitle}>{isActive ? 'Copied' : 'Copy Link'}</span>
      )}
    </li>
  );
};

export default CopyButton;
